import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { HeartIconVIPMessage } from '@module/types/centrifuge/public-message/heartIconVIPMessageTypes';
import { checkIsMobile } from '@module/utils/checkIsMobile';
import TimeConstants from '@module/utils/item';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import useChatPanelStore from '../stores/useChatPanelStore';
import { ContextualError } from '../utils/error/context-error';
import { aspCond } from './conditions/condition';
import { useQueue } from './useQueue';
export default function useHeartIconVIPOverlaySponEffect() {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queue = useQueue(t0);
  const timerIdRef = useRef(null);
  const deviceOrientation = useChatPanelStore(_temp);
  let t1;
  bb0: {
    if (typeof window === "undefined") {
      t1 = null;
      break bb0;
    }
    if (checkIsMobile()) {
      if (deviceOrientation === "portrait") {
        t1 = "mp";
        break bb0;
      }
      if (deviceOrientation === "landscape") {
        t1 = "ml";
        break bb0;
      }
    } else {
      t1 = "pc";
      break bb0;
    }
    throw new ContextualError("device orientation and/or device not set", {});
  }
  const userDevice = t1;
  let t2;
  if ($[1] !== queue || $[2] !== userDevice) {
    t2 = payload => {
      if (userDevice === null) {
        return;
      }
      queue.enqueue(payload);
    };
    $[1] = queue;
    $[2] = userDevice;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const enqueue = t2;
  let t3;
  bb1: {
    if (queue.length === 0) {
      t3 = null;
      break bb1;
    }
    if (queue.first && "data" in queue.first && "message" in queue.first.data) {
      let t4;
      if ($[4] !== queue.first.data.message) {
        t4 = queue.first.data.message.at(0);
        $[4] = queue.first.data.message;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t3 = t4;
      break bb1;
    }
    t3 = null;
  }
  const heartIconVipAssets = t3;
  let t4;
  let t5;
  if ($[6] !== queue || $[7] !== userDevice) {
    t4 = () => {
      if (queue.length === 0) {
        return;
      }
      if (!queue.first.data.message.length) {
        return;
      }
      if (!userDevice) {
        return;
      }
      const firstMessage = queue.first.data.message.at(0);
      if (!firstMessage || !firstMessage[userDevice]) {
        console.warn("Invalid message format received:", firstMessage);
        queue.dequeue();
        return;
      }
      const timeTillDequeue = firstMessage[userDevice].sec;
      if (!timerIdRef.current) {
        timerIdRef.current = setTimeout(() => {
          queue.dequeue();
          timerIdRef.current = null;
        }, Number(timeTillDequeue) * TimeConstants.ONE_SECOND);
      }
    };
    t5 = [queue, userDevice];
    $[6] = queue;
    $[7] = userDevice;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== heartIconVipAssets) {
    t6 = type => {
      const asset = heartIconVipAssets?.[type];
      if (!asset?.url) {
        return null;
      }
      return <img id="heart-icon-vip-overlay" className={cn("pointer-events-none fixed top-0 left-0 z-max h-screen w-screen object-cover", {
        "h-[1360px]": aspCond.if("iframe-asp")
      })} aria-hidden={true} src={asset.url} alt="Heart Icon VIP Overlay" />;
    };
    $[10] = heartIconVipAssets;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const createOverlayElem = t6;
  if (!queue.length) {
    let t7;
    if ($[12] !== enqueue) {
      t7 = {
        overlayElem: null,
        enqueue
      };
      $[12] = enqueue;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  if (userDevice === "pc" || userDevice === "mp" || userDevice === "ml") {
    let t7;
    if ($[14] !== createOverlayElem || $[15] !== userDevice) {
      t7 = createOverlayElem(userDevice);
      $[14] = createOverlayElem;
      $[15] = userDevice;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== enqueue || $[18] !== t7) {
      t8 = {
        overlayElem: t7,
        enqueue
      };
      $[17] = enqueue;
      $[18] = t7;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    return t8;
  }
  throw new ContextualError("device orientation and/or device not set", {
    deviceOrientation,
    userDevice,
    window,
    queue,
    timerIdRef,
    heartIconVipAssets
  });
}
function _temp(s) {
  return s.deviceOrientation;
}